"use client";

import styles from "@/styles/global/expedite-dialog.module.scss";
import Image from "next/image";
import { useEffect, useState } from "react";
import Dialog from "@/components/global/Dialog";

interface ExpediteDataType {
  // 根据后端返回结构扩展字段；这里做兜底展示
  message?: string;
  items?: Array<{
    quantity?: number | string;
    [key: string]: any;
  }>;
  orderID?: number | string;
  [key: string]: any;
}

export default function ExpediteDialog() {
  const [visible, setVisible] = useState(false);
  const [expediteData, setExpediteData] = useState<ExpediteDataType | null>(
    null
  );

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("expeditData");
      if (raw) {
        let parsed: ExpediteDataType | null = null;
        try {
          parsed = JSON.parse(raw);
        } catch {
          // 非 JSON 字符串则以纯文本展示
          parsed = { message: String(raw) } as ExpediteDataType;
        }
        setExpediteData(parsed);
        setVisible(true);
      }
    } catch {
      // 静默处理
    }
  }, []);

  if (!visible) return null;

  const totalQuantity = Array.isArray(expediteData?.items)
    ? expediteData!.items!.reduce((sum: number, item: any) => {
        const qty = Number(item?.quantity) || 0;
        return sum + qty;
      }, 0)
    : 0;

  const items: any[] = Array.isArray(expediteData?.items) ? expediteData!.items! : [];
  const visibleItems = items.slice(0, 3);
  const totalAmount = (() => {
    const num = Number((expediteData as any)?.total);
    return Number.isFinite(num) ? num : 0;
  })();

  return (
    <Dialog
      visible={visible}
      title="You have an unpaid order"
      closeable={true}
      showConfirmButton={true}
      showCancelButton={true}
      confirmButtonText="PAY NOW"
      cancelButtonText="IGNORE"
      onClose={() => {
        setVisible(false);
      }}
      onCancel={() => {
        sessionStorage.removeItem("expeditData");
        setVisible(false);
      }}
      onConfirm={() => {
        setVisible(false);
        const oid = (expediteData as any)?.orderID;
        if (oid) {
          window.location.href = `/account/order-details/oid/${oid}`;
        }
      }}
    >
      <div className={styles["expedite-dialog-content"]}>
        <div className={styles["expedite-num"]}>
          {totalQuantity} items are waiting for payment:
        </div>

        <div className={styles["expedite-list"]}>
          {visibleItems.map((item: any, index: number) => {
            const src = item?.defaultNewThumbnailUrl || item?.defaultFullUrl;
            if (!src) return null;
            return (
              <div key={item?.productID || index} className={styles["expedite-image-wrap"]}>
                <Image
                  width={60}
                  height={60}
                  src={src}
                  alt={String(item?.name || "product")}
                  className={styles["expedite-image"]}
                />
                <span className={styles["expedite-qty-badge"]}>X{Number(item?.quantity) || 0}</span>
              </div>
            );
          })}
          {items.length > 3 ? (
            <div className={styles["expedite-more"]}
            onClick={() => {
              setVisible(false);
              const oid = (expediteData as any)?.orderID;
              if (oid) {
                window.location.href = `/account/order-details/oid/${oid}`;
              }
            }}>more</div>
          ) : null}
        </div>

        <div className={styles["expedite-total-box"]}>
          <div className={styles["expedite-total-title"]}>Pay only:</div>
          <div className={styles["expedite-total-num"]}>${totalAmount.toFixed(2)}</div>
        </div>
      </div>
    </Dialog>
  );
}
